// System-managed line item configs. These are applied/adjusted by automated
// flows (coupons, processing fees, refund adjustments) and should not be
// hand-edited or manually appended to invoices.
const PROTECTED_LINE_ITEM_CONFIGS = [
  { type: 'discount', subtype: 'coupon' },
  { type: 'discount', subtype: 'parent' },
  { type: 'discount', subtype: 'school' },
  { type: 'discount', subtype: 'bhcs_student' },
  { type: 'discount', subtype: 'foster_city_resident' },
  { type: 'discount', subtype: 'comp' },
  { type: 'fee', subtype: 'processing' },
  { type: 'refund', subtype: 'payment_adjustment' }
];

// Shared predicate: is this config one of the system-managed (protected) ones?
export function isProtectedLineItemConfig(config: { type: string; subtype?: string | null }): boolean {
  return PROTECTED_LINE_ITEM_CONFIGS.some(
    protectedConfig =>
      config.type === protectedConfig.type &&
      config.subtype === protectedConfig.subtype
  );
}
